/* eslint-disable no-param-reassign */
/* eslint-disable no-unsafe-optional-chaining */
import { startCase } from "lodash";
import { ROLES_KEY_MAPPER } from "../../contants";
import { isEmptyObj } from "../../utils/helper";

export const selectUserProfile = (state) => state.auth?.userProfile?.data;

export const selectDistrictSiUser = (state) =>
  Boolean(state.auth?.userProfile?.data?.districtSi);

export const selectUserRole = (state) =>
  state.auth?.userProfile?.data?.assignedRoles?.[0];

export const selectAllSIUsers = (state) => {
  const {
    districtSi,
    chapterSi,
    regionSi,
    areaSi,
    zoneSi,
    helpDesk,
    districtLeader,
    chapterLeader,
    regionLeader,
    zoneLeader,
    areaLeader,
    nationalLeader,
    helpDeskAdmin,
    nationalSi,
  } = selectUserProfile(state) || {};

  return {
    isDistrictSi: districtSi,
    isChapterSi: chapterSi,
    isRegionSi: regionSi,
    isAreaSi: areaSi,
    isZoneSi: zoneSi,
    isHelpDesk: helpDesk,
    isDistrictLeader: districtLeader,
    isChapterLeader: chapterLeader,
    isRegionLeader: regionLeader,
    isZoneLeader: zoneLeader,
    isAreaLeader: areaLeader,
    isNationalLeader: nationalLeader,
    isHelpDeskAdmin: helpDeskAdmin,
    isNationalSi: nationalSi,
  };
};

export const selectOSKeysByUserRole = (state) => {
  const userRole = selectUserRole(state);
  return ROLES_KEY_MAPPER[userRole];
};

export const selectOSIdByUserRole = (state) => {
  const osKeys = selectOSKeysByUserRole(state);
  const userData = selectUserProfile(state);

  if (!Array.isArray(osKeys) || !userData) return {};

  return osKeys.reduce((result, key) => {
    result[key] = userData[key];
    return result;
  }, {});
};
export const selectOSNamesByUserRole = (state) => {
  const osKeys = selectOSKeysByUserRole(state);
  const userData = selectUserProfile(state);

  if (!Array.isArray(osKeys) || !userData) return {};

  const osKeysWithName = osKeys.map((key) => `${key.split("Id")[0]}Name`);

  return osKeysWithName.reduce((result, key) => {
    result[key] = userData[key];
    return result;
  }, {});
};

export const selectChiefLocByUserRole = (state) => {
  const userRole = selectUserRole(state);
  const userData = selectUserProfile(state);

  if (!userRole || isEmptyObj(userData)) return "";

  const chiefKey = userRole?.split(/SI|Leader|DeputySI/)[0];
  const chiefLoc = userData[`${chiefKey}Name`] || "India";

  return `${startCase(userRole)} - ${chiefLoc}`;
};

export const selectUserStructureIds = (state) => {
  const disabledOSKeys = selectOSKeysByUserRole(state);
  const userData = selectUserProfile(state);

  return disabledOSKeys?.length
    ? disabledOSKeys.reduce((acc, key) => {
        if (userData[key]) {
          return { ...acc, [key]: userData[key] };
        }
        return acc;
      }, {})
    : {};
};
